import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  inject,
  signal,
} from '@angular/core';

import { StatusModel } from '@core/models/status.model';
import * as fromRoot from '@core/redux';
import * as StatusActions from '@core/redux/status/status.actions';
import { Store } from '@ngrx/store';
import { NgClickOutsideDirective } from 'ng-click-outside2';

import { SelectColorComponent } from '../select-color/select-color.component';

@Component({
  selector: 'app-board-column-menu',
  templateUrl: './board-column-menu.component.html',
  styleUrls: ['./board-column-menu.component.less'],
  imports: [SelectColorComponent, NgClickOutsideDirective],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoardColumnMenuComponent {
  private readonly store = inject<Store<fromRoot.State>>(Store);

  // Keep @Input for backward compatibility
  @Input() model!: StatusModel;

  // Keep @Output for backward compatibility
  @Output() onClose = new EventEmitter<void>();

  // Internal state management
  private readonly confirmDeleteState = signal(false);

  // Computed values
  protected readonly deleteButtonText = computed(() => (this.confirmDeleteState() ? 'Вы уверены?' : 'Удалить'));

  onDelete(): void {
    if (this.confirmDeleteState()) {
      this.store.dispatch(new StatusActions.DeleteAction(this.model));
      this.confirmDeleteState.set(false);
    } else {
      this.confirmDeleteState.set(true);
    }
  }

  onChangeColor(color: string): void {
    if (color !== this.model.color) {
      const updatedModel = {
        ...this.model,
        color,
      } as StatusModel;

      this.store.dispatch(new StatusActions.SaveAction(updatedModel));
    }
  }
}
